import React from 'react';

import { FileUploadIcon } from './FileUploadIcon';

export const FileUploadOnlyExcelIcon = () => {
  return <FileUploadIcon onlyExcel />;
};
